import { useCallback } from 'react';
import * as Sentry from '@sentry/nextjs';
import logger from '@/utils/logger';
import { useToast } from '@/hooks/useToast';
const PREFIX = 'components: Editor: hooks: useParseFileUpload:';

const useParseFileUpload = _ref => {
  let {
    uploadFn,
    subscriptionActive,
    onSuccess,
    onBeforeUpload
  } = _ref;
  const {
    addToast: sendNotification
  } = useToast(); // Parse user file upload and replace
  // the current workbook content

  const parseFileUpload = useCallback((file, originData) => {
    typeof onBeforeUpload === 'function' && onBeforeUpload();
    uploadFn(file, originData, subscriptionActive).then(_ref2 => {
      let {
        warnings
      } = _ref2;
      sendNotification({
        type: 'success',
        description: 'Successfully uploaded'
      }); // Trigger the onSuccess callback

      typeof onSuccess === 'function' && onSuccess(); // Send file upload warnings

      if (warnings.length) {
        warnings.forEach(warning => {
          if (!warning.userMessage) return;
          logger.warn(`${PREFIX} parseFileUpload: ${warning}`);
          sendNotification({
            type: 'warning',
            description: warning.userMessage
          });
        });
      }
    }).catch(err => {
      logger.error(`${PREFIX} parseFileUpload: ${err}`);
      sendNotification({
        type: 'error',
        description: err.userMessage || 'Unexpected error during upload'
      });
      Sentry.captureException(Error(`${PREFIX}: parseFileUpload: file type "${file.type || 'unknown'}" w/ size: "${file.size}" Code(${err.code}): ${err}`));
    });
  }, [sendNotification, subscriptionActive, uploadFn, onSuccess, onBeforeUpload]);
  return {
    parseFileUpload
  };
};

export default useParseFileUpload;